import BaseApiService from './api/base';
import { PlantPerformance, Alert, AlertsResponse, CommunicationResponse, ApiFilters } from '../types';

class FaultIntelligenceService extends BaseApiService {
  async getPerformance(plantId: string, date?: string): Promise<PlantPerformance> {
    const params = this.buildParams({ plant_id: plantId, date });
    return this.get(`/api/alerts/api/dashboard/performance/?${params}`);
  }

  async getAlerts(filters: ApiFilters = {}): Promise<AlertsResponse> {
    const params = this.buildParams({ 
      plant_id: filters.plantId, 
      date: filters.date, 
      type: filters.type, 
      status: filters.status 
    });
    return this.get(`/api/alerts/api/dashboard/alerts/?${params}`);
  }

  async getCommunicationStatus(plantId?: string): Promise<CommunicationResponse> {
    const params = this.buildParams({ plant_id: plantId });
    return this.get(`/api/alerts/api/dashboard/communication_status/?${params}`);
  }

  async acknowledgeAlert(alertId: string, acknowledgedBy: string): Promise<Alert> {
    return this.patch(`/api/alerts/api/dashboard/${alertId}/acknowledge_alert/`, {
      acknowledged_by: acknowledgedBy
    });
  }

  async resolveAlert(alertId: string): Promise<Alert> {
    return this.patch(`/api/alerts/api/dashboard/${alertId}/resolve_alert/`);
  }

  async createAlert(alertData: Partial<Alert>): Promise<Alert> {
    return this.post('/api/alerts/api/dashboard/create_alert/', alertData);
  }
}

export const faultIntelligenceService = new FaultIntelligenceService();